<template>
	<section class="flex flex-col items-center justify-between lg:col-span-2 panel lg:flex-row lg:mt-6">
		<div class="flex flex-col items-center text-center lg:flex-row lg:text-left lg:space-x-6">
			<ExclamationTriangleIcon
				v-if="hasOverdue"
				class="h-10 text-red-500"
			/>
			<div class="flex flex-col">
				<span class="text-sm uppercase text-mx-gray-500 dark:text-mx-gray-400">
					{{ t('account-page.due-today') }}
				</span>
				<span class="text-xl font-semibold">
					{{ overdueBalance }}
				</span>
			</div>
		</div>
		<LinkButton
			v-if="totalOverdueAmount"
			class="w-full mt-2 lg:w-56"
			:text="t('account-page.buttons.make-payment')"
			to="/billing/invoices"
		/>
	</section>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

interface Props {
	hasOverdue: boolean
	overdueBalance: string
	totalOverdueAmount?: number
}

defineProps<Props>()

const { t } = useI18n()
</script>
